import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Project,
  ProjectConfiguration,
  zone,
  project as projectMock,
  Identifiable,
  ProjectPortfolio,
} from "@planzone/dto";
import {
  useCreateProjectModelFromProject,
  useRetrieveProjectToolsConfiguration,
} from "@planzone/view-models";
import { ProjectCreationForm } from "../projectCreationForm";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectModelCreationFromProject({ project, close }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, createProjectModelFromProject } =
    useCreateProjectModelFromProject();
  const {
    isRequestPending: isConfRequestPending,
    isRequestSuccess: isConfRequestSuccess,
    isRequestFailure: isConfRequestFailure,
    config,
    retrieveProjectToolsConfiguration,
  } = useRetrieveProjectToolsConfiguration(project);
  const [formData, setFormData] = React.useState<
    Project & { portfolios: Identifiable<ProjectPortfolio>[] }
  >({
    ...projectMock,
    ...project,
    isTemplate: true,
    portfolios: [],
  });
  const [configuration, setConfiguration] =
    useState<ProjectConfiguration>(config);

  React.useEffect(() => {
    !isConfRequestPending &&
      !isConfRequestSuccess &&
      !isConfRequestFailure &&
      retrieveProjectToolsConfiguration(project);
  }, []);

  React.useEffect(() => {
    setConfiguration(config);
  }, [config]);

  return (
    <Modal header={t("projectModelCreationFromProject.title")} close={close}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          event.stopPropagation();
          createProjectModelFromProject({
            project,
            projectModel: formData,
            configuration,
          });
        }}
        className={styles.form}
      >
        <ProjectCreationForm
          zone={{ ...zone, uuid: "" }}
          formData={formData}
          configuration={configuration}
          template={project}
          editForm={setFormData}
          setConfiguration={setConfiguration}
        />
        <div className={styles.buttons}>
          <Button type="cancel" press={close}>
            {t("projectModelCreationFromProject.cancel")}
          </Button>
          <Button type="submit" status={isRequestPending ? "pending" : "none"}>
            {t("projectModelCreationFromProject.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { ProjectModelCreationFromProject };
